import axios from 'axios';
import { baseApi, token } from '../../../services/Apis';

export const reservacionesClasesApi = `${baseApi}/class-reservations`;

export const getAllReservacionesClasesService = async (params) => {
  const res = await axios.get(reservacionesClasesApi, {
    headers: await token({}),
    params,
  });
  return res;
};

export const saveReservacionesClasesService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.put(`${reservacionesClasesApi}/${id}`, data, {
      headers: await token({}),
    });
  } else {
    res = await axios.post(`${reservacionesClasesApi}`, data, {
      headers: await token({}),
    });
  }
  return res.data;
};

export const getOneReservacionesClasesService = async (id) => {
  const res = await axios.get(`${reservacionesClasesApi}/${id}`, {
    headers: await token({}),
  });
  return res;
};

export const deleteReservacionesClasesService = async (id) => {
  const res = await axios.delete(`${reservacionesClasesApi}/${id}`, {
    headers: await token({}),
  });
  return res;
};
